import React from "react";
import HourRow from "./hourRow";

export interface HourRangeProps {
	startHour: string | Date;
	endHour: string | Date;
	hourHeight: number;
	scope?: any;
}

const HourRange: React.FC<HourRangeProps> = ({ startHour, endHour, hourHeight, scope }) => {
	const generateHours = () => {
		const startDateTime = new Date(startHour);
		const endDateTime = new Date(endHour);
		const hours: React.ReactNode[] = [];

		while (startDateTime <= endDateTime) {
			const formattedDateTime = startDateTime.toTimeString().slice(0, 5);
			hours.push(
				<HourRow
					key={formattedDateTime}
					hourHeight={hourHeight}
					hour={`2000-01-01T${formattedDateTime}:00`}
					scope={scope}
				/>
			);

			startDateTime.setHours(startDateTime.getHours() + 1);
		}

		return hours;
	};

	return (
		<div className="calendar-bg calendar-rows">
			{generateHours()}
		</div>
	);
};

export default HourRange;